import React from 'react';

import HorizontalScroller from 'components/uiLibrary/HorizontalScroller';

import { SUB_COMPONENTS } from 'components/Globals/Analytics/constants';
import PreviewCard from 'components/Globals/PreviewCard';

import { ENTITY_TYPE_ID_PREFIX } from 'operabase-router/constants';

import classes from './EntitySwimLane.module.scss';

const EntitySwimLane = ({ data = [], trackingData = {} }) => (
  <HorizontalScroller hideArrow>
    <ul className={classes.root}>
      {data.map(item => (
        <li key={`${ENTITY_TYPE_ID_PREFIX[item.entityType]}-${item.entity.id}`}>
          <PreviewCard
            entity={item.entity}
            entityType={item.entityType}
            trackingData={{
              ...trackingData,
              subComponent: SUB_COMPONENTS.PREVIEW_CARD,
            }}
          />
        </li>
      ))}
    </ul>
  </HorizontalScroller>
);

export default EntitySwimLane;
